import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table, Input, FormGroup, Label } from 'reactstrap';
import { AppContext } from '../../application/provider';
import PagosPlanillaService from '../../axios_services/pagosplanilla.service';
import Loader from '../Loader/Loader';

const ModalColaboradorPagoChecklist = ({ isOpen, onClose, onRefresh }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [colaboradores, setColaboradores] = useState([]);
    const [areaFilter, setAreaFilter] = useState('1'); // Por defecto Administración
    const [perfilFilter, setPerfilFilter] = useState('');

    const perfiles = state.catalogos?.perfiles || [];
    const filteredPerfiles = perfiles.filter(p => String(p.macro_area_id) === String(areaFilter));

    useEffect(() => {
        if (isOpen) {
            // Si no hay perfil seleccionado o el actual no pertenece al área, seleccionar el primero disponible
            if (filteredPerfiles.length > 0 && (!perfilFilter || !filteredPerfiles.some(p => String(p.perfil_id) === String(perfilFilter)))) {
                setPerfilFilter(String(filteredPerfiles[0].perfil_id));
            }
            loadData();
        }
    }, [isOpen, areaFilter, perfilFilter]);

    const loadData = async () => {
        if (!areaFilter || !perfilFilter) return;
        setIsLoading(true);
        try {
            const resp = await PagosPlanillaService.getColaboradoresConfig(areaFilter, perfilFilter);
            setColaboradores(resp.data.data || []);
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleToggle = async (usuarioId, current) => {
        setIsLoading(true);
        try {
            const nextValue = current ? 0 : 1;
            await PagosPlanillaService.updateColaboradorConfig({ usuario_id: usuarioId, tracked: nextValue });
            
            setColaboradores(prev => prev.map(c => 
                c.usuario_id === usuarioId ? { ...c, tracked: nextValue } : c
            ));
            
            if (onRefresh) onRefresh();
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>GESTIÓN DE COLABORADORES - PLANILLA</h1>
                    <button className="close-btn" onClick={onClose}>X</button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <div className="px-4 pt-4">
                        <p className="text-muted mb-4" style={{ fontSize: '12px', lineHeight: '1.2' }}>
                            Marque los colaboradores que serán incluidos en el módulo de pagos de planilla.
                        </p>

                        <FormGroup className="mb-4">
                            <Label>Área:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={areaFilter}
                                onChange={(e) => {
                                    const nextArea = e.target.value;
                                    setAreaFilter(nextArea);
                                    // El perfil se actualizará en el useEffect
                                }}
                            >
                                <option value="1">ADMINISTRACIÓN</option>
                                <option value="2">NEGOCIOS</option>
                                <option value="4">GERENCIA</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-4">
                            <Label>Perfil:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={perfilFilter}
                                onChange={(e) => setPerfilFilter(e.target.value)}
                            >
                                {filteredPerfiles.map(p => (
                                    <option key={p.perfil_id} value={p.perfil_id}>{p.descripcion.toUpperCase()}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </div>

                    {isLoading && <Loader />}
                    
                    <div className="px-4 pb-4">
                        <div className="table-container table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <Table striped hover size="sm" className="mb-0 text-xs">
                                <thead className="bg-[#14233a] text-white sticky-top">
                                    <tr>
                                        <th className="p-2">Colaborador</th>
                                        <th className="p-2">Cargo</th>
                                        <th className="text-center p-2">Habilitar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {colaboradores.length > 0 ? colaboradores.map(c => {
                                        const isTracked = Number(c.tracked) === 1;
                                        return (
                                            <tr key={c.usuario_id}>
                                                <td className="p-2 align-middle">{c.nombre_completo.toUpperCase()}</td>
                                                <td className="p-2 align-middle">{c.cargo}</td>
                                                <td className="text-center p-2 align-middle">
                                                    <Input 
                                                        type="checkbox" 
                                                        checked={isTracked} 
                                                        onChange={() => handleToggle(c.usuario_id, isTracked)} 
                                                        style={{ position: 'relative', margin: 0, width: '18px', height: '18px', cursor: 'pointer' }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    }) : (
                                        <tr>
                                            <td colSpan="3" className="text-center p-4 text-muted">No se encontraron colaboradores.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalColaboradorPagoChecklist;
